import {PickerColumn} from 'src/tracker/model/column/tracker-column'
import {woiProperty} from 'src/tracker/model/property/equipment/weapon/woi-property'

export const woiColumn = new PickerColumn(
  "85px",
  woiProperty
)
